<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
        <v-select
          outlined
          v-model="SelStatus"
          :items="StatusName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
          return-object
          @change="clearData"
          hide-details
          full-width
        ></v-select>
        <v-btn color="primary" class="ml-3" raised dark large @click="load">
          RELOAD
        </v-btn>
        <v-btn
          color="success"
          class="ml-3"
          raised
          dark
          large
          @click="savechanges"
        >
          SAVE CHANGES
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Choose Status(s)</v-card-text>

          <v-data-table
            v-model="selected"
            :headers="hdrreason"
            :items="arrreason"
            item-key="status_id"
            @click:row="handleClick"
            dense
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Selected Reason(s)- CompID- {{tempCompID}}</v-card-text>
          
          <v-data-table
          v-model="selected1"
            :headers="hdr1reason"
            :items="arr1reason"
            item-key="reason_id"
            show-select
            dense
            :loading="loading"
            :search="search1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search1"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>
           
            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    selected1:[],
    StatusName: [],
    SelStatus: "",
    search: "",
    search1: "",
    btrue: true,
    tempCompID:"",
    inputclass: {
      eid: "",
      sid: "",
      rid: [],
    },

    arrreason: [],
    hdrreason: [
      { text: "ID", value: "status_id" },
      { text: "Status Name", value: "status_name" },
    
    ],

    arr1reason: [],
    hdr1reason: [
      { text: "ID", value: "reason_id" },
      { text: "Reason Name", value: "reason_name" },
    ],

    editedItem: {
      reason_id: "",
      reason_name: 0,
      status_id: 0,
      mapping_status: false,
    },
  }),

  
  mounted() {
    this.bindcompanytype();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {
    },
    bindcompanytype: function(){
      
    }

  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    addvalue: function (id, name, cid, status) {
     console.log(id + " " + name + " " + cid + " " + status);
      this.editedItem.reason_id = id;
      this.editedItem.reason_name = name;
      this.editedItem.status_id = cid;
      this.editedItem.mapping_status = "true";
      this.arr1reason.push(this.editedItem);
      //  this.arr1jobtype.splice()
    },
    clearData: function () {
      this.arrreason = [];
      this.selected = [];
      this.selected1 = [];
    },
    load: function () {
      this.arr1reason=[];
      this.selected = [];
      this.selected1 = [];
      this.loading = true;
      this.Gridbindjobtype(this.SelStatus.event_id);
    },
    savechanges: function () {
      if(this.selected1.length<=0)
      {
        this.showSnackbar("error", "Select Job type before save !");
      return;
      }
      this.inputclass.rid = [];
      this.selected1.forEach((el) => {
        this.inputclass.rid.push(el.reason_id);
      });
      this.inputclass.eid = this.SelStatus.event_id;
      this.inputclass.sid = this.tempCompID;
console.log(this.inputclass);
      axios
        .post(this.$apiPath + "Event_Reason", this.inputclass, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.showSnackbar("Success", "Event and  Reason merged !");
            this.Reload();
          }
        })
        .catch()
        .finally();
    },

    handleClick(value) {

      this.tempCompID=value.status_id;
      this.GridbindjobtypeForevent(value.status_id);
    },
    bindcompanytype: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.StatusName = res.data.result;
        })
        .catch()
        .finally();
    },

    Gridbindjobtype: async function (comid) {
     // alert("CompanyType/GetByEventId/");
      await axios
        .get(this.$apiPath + "Event_status/ByEventId/" + comid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrreason = res.data.result;
          // this.selected = this.arrreason.filter(
          //   (task) => task.event_id == this.SelStatus.event_id
          // );
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },

 GridbindjobtypeForevent: async function (cid) {
  //GetByEventIDCompanyType
  //VendorApp/getJobtype
  //alert("JobType/GetByEventIDCompanyTypeAll/");
      await axios
        .get(this.$apiPath + "Event_Reason/GetMappingByEventId/" + this.SelStatus.event_id + "/" + cid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          //console.log("data aaye");
         // console.log(res.data.result);
          this.arr1reason = res.data.result;
           this.selected1 = this.arr1reason.filter(
             (task) => task.event_id == this.SelStatus.event_id
           );
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },

  },
};
</script>